var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-table-body-cell',_vm._b({},'iv-base-table-body-cell',{ ..._vm.$attrs, ..._vm.$props },false),[_c('iv-image',_vm._b({},'iv-image',{
            src: _vm.$props.value,
            style: { height: '80px' },
            ..._vm.$attrs,
            ..._vm.$props,
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }